<script lang="ts">
	import SalesSlugPage from "./sales-slug-page.svelte";
	import type { RouterOutputs } from "#trpc/router.js";

	type PublicListing = RouterOutputs["public"]["investmentListings"]["getActiveListings"][number];

	let {
		salesTeam,
		listing
	}: {
		salesTeam: {
			displayName: string;
			title: string;
			headshot: string;
			workEmail: string;
			workNumber: string | null;
		}[];
		listing: PublicListing;
	} = $props();
</script>

<SalesSlugPage {listing} {salesTeam} />
